<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">チャージトラック種別詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_CTT_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :disabled="form.id"
                :rules="codeRules"
                clearable
                label="トラックタイプ"
                v-model.trim="form.code"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="nameRules"
                clearable
                label="トラック名称"
                v-model="form.name"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="volumeRules"
                clearable
                label="最大積載C/W"
                v-model="form.max"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null,
      },
      nameRules: [(v) => !!v || "トラック名称 is required"],
      codeRules: [(v) => !!v || "トラックタイプ is required"],
      volumeRules: [(v) => !!v || "最大積載C/W is required"],
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  methods: {
    save() {
      this.$http
        .post("/truck-types", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
};
</script>
